import Button from '@mui/material/Button';

interface CarouselSkipLinkProps {
    id: string;
    href: string;
    text: string;
}

// The opacity and absolute positioning is to make the button focusable by tab but still invisible.
// A display:none will make it unfocusable, and simply making it transparent still adds spacing and the possibility of "seeing" it via cursor.
export const CarouselSkipLink = ({ id, href, text }: CarouselSkipLinkProps) => (
    <Button
        id={id}
        size="small"
        variant="outlined"
        href={href}
        sx={{
            opacity: 0,
            position: 'absolute',
            left: '-9999px',
            transition: 'all 0.2s ease',
            margin: '8px auto 8px 0 !important',
            '&:focus': {
                position: 'static',
                left: 'auto',
                opacity: 1,
            },
        }}
    >
        {text}
    </Button>
);
